(function () {
    'use strict';

    angular
        .module('bluebookApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
            .state('facesheet-section', {
                parent: 'entity',
                url: '/facesheet-section',
                data: {
                    authorities: [],
                    pageTitle: 'FacesheetSections'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/entities/facesheet-section/list/facesheet-section.html',
                        controller: 'FacesheetSectionController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    access: ['Auth', 'ACTIONS', function (Auth, ACTIONS) {
                        var actions = [ACTIONS.ACTION_MAIN_MENU_TEMPLATES_FACESHEET_SECTION];
                        return Auth.loadActionsAccess(actions).$promise;
                    }]
                },
                onEnter: ['Auth', 'ACTIONS', 'access', function (Auth, ACTIONS, access) {
                    Auth.checkActionAuthorization(ACTIONS.ACTION_MAIN_MENU_TEMPLATES_FACESHEET_SECTION, access);
                }]
            });
    }
})();
